import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/snippets/poshmark-one-item-bundle';

export default function Example() {
  return (
    <>
      <Head>
        <title>What do I do with Single Item Bundles on Poshmark? | OneShop Blog</title>
        <meta
          name='description'
          content='Did someone leave you hanging with a single item bundle? Here’s what it could mean and what you can do!'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/poshmark-one-item-bundle' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/poshmark-one-item-bundle' />
        <meta property='og:title' content='What do I do with Single Item Bundles? | OneShop Blog' />
        <meta
          property='og:description'
          content='Did someone leave you hanging with a single item bundle? Here’s what it could mean and what you can do!'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2021-07-08T00:00:00.000Z' />
        <meta property='article:modified_time' content='2021-07-08T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
